import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.categorias.length > 0)?_c(VBadge,{staticClass:"ml-6",attrs:{"overlap":"","color":"white"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('span',{staticClass:"text-black"},[_vm._v(_vm._s(_vm.categorias.length))])]},proxy:true}],null,false,565882303)},[_c(VBtn,{attrs:{"color":"#042333","dark":"","small":""},on:{"click":_vm.adicionarProdutosCarrinho}},[_c(VIcon,{staticClass:"mr-1",attrs:{"size":"19"}},[_vm._v("mdi-cart")]),_vm._v("\n    adicionar\n  ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }